export const DRAWER_WIDTH = 240;
export const DRAWER_COLLAPSED_WIDTH = 64;
export const DRAWER_COLLAPSED_MOBILE_WIDTH = 52;
